// Client logos (files in public/clients). Replace alt text with client names when available.
export const CLIENT_LOGOS = Array.from({ length: 38 }, (_, i) => `/clients/logo-${String(i + 1).padStart(2, "0")}.webp`);
